/**
 * Image & Text Slider — view.js
 *
 * Initialises Swiper for each .nl-image-text-slider instance on the page.
 * Loaded via block viewScript — only runs on the frontend.
 */

document.addEventListener( 'DOMContentLoaded', () => {
    const sliders = document.querySelectorAll( '.nl-image-text-slider' );

    sliders.forEach( ( el ) => {
        el.querySelectorAll( '.swiper-slide' ).forEach( ( slide ) => {

            slide.querySelector( 'h2' )
                ?.setAttribute( 'data-swiper-parallax', '-80' );
            slide.querySelector( 'h2' )
                ?.setAttribute( 'data-swiper-parallax-opacity', '0' );
            slide.querySelector( 'h2' )
                ?.setAttribute( 'data-swiper-parallax-duration', '500' );

            slide.querySelector( 'p' )
                ?.setAttribute( 'data-swiper-parallax', '-80' );
            slide.querySelector( 'p' )
                ?.setAttribute( 'data-swiper-parallax-opacity', '0' );
            slide.querySelector( 'p' )
                ?.setAttribute( 'data-swiper-parallax-duration', '650' );

            slide.querySelector( '.wp-block-buttons' )
                ?.setAttribute( 'data-swiper-parallax', '-80' );
            slide.querySelector( '.wp-block-buttons' )
                ?.setAttribute( 'data-swiper-parallax-opacity', '0' );
            slide.querySelector( '.wp-block-buttons' )
                ?.setAttribute( 'data-swiper-parallax-duration', '800' );

        } );

        new Swiper( el, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 900,
            keyboard: { enabled: true },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            parallax: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
                stopOnLastSlide: false,
            },
            pagination: {
                el: el.querySelector( '.nl-slider-pagination' ),
                clickable: true,
                bulletClass: 'nl-slider-bullet',
                bulletActiveClass: 'nl-slider-bullet--active',
                renderBullet: ( index, className ) => {
                    return `<span class="${ className }"></span>`;
                },
            },
        } );
    } );
} );
